/* Search cards only. Keep Swym's action markup, consent UI and SDK handlers. */
(function () {
  'use strict';
  if (window.TpSearchWishlistInstalled) return;
  window.TpSearchWishlistInstalled = true;

  var scope = '.search-page, [data-nav-search-results], .gl-fullscreen-layer';
  var buttonSelector = 'button.swym-button.swym-add-to-wishlist-view-product[data-swaction="addToWishlist"]';
  var heartPath = 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z';
  var scheduled = false;
  var observedMedia = new Set();
  var mediaObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;

  function visibleMedia(media, card) {
    if (!media || !card.querySelector('a[href*="/products/"]')) return false;
    var bounds = media.getBoundingClientRect();
    if (bounds.width < 28 || bounds.height < 28) return false;
    // Unlike a child SVG, ancestors must not be allowed to override hidden
    // carousel slides. No viewport test: offscreen, scrollable cards are valid.
    for (var node = media; node && node !== document.body; node = node.parentElement) {
      var style = getComputedStyle(node);
      if (node.hidden || node.getAttribute('aria-hidden') === 'true' ||
          style.display === 'none' || style.visibility !== 'visible' ||
          Number(style.opacity) === 0) return false;
    }
    return true;
  }

  function consentPopupAvailable() {
    return window.SwymConsentManager &&
      typeof window.SwymConsentManager.checkConsent === 'function' &&
      window.SwymConsentPopupManager &&
      typeof window.SwymConsentPopupManager.show === 'function' &&
      document.getElementById('swym-consent-popup');
  }

  function refresh() {
    scheduled = false;
    var activeMedia = new Set();
    document.querySelectorAll('.tp-search-wishlist').forEach(function (button) {
      if (button.closest(scope)) return;
      button.classList.remove('tp-search-wishlist', 'tp-search-wishlist-ready');
      var oldCard = button.closest('.product-grid-item, .gl-card');
      if (oldCard) oldCard.classList.remove('tp-search-wishlist-card-ready');
    });
    document.querySelectorAll(scope).forEach(function (root) {
      root.querySelectorAll(buttonSelector).forEach(function (button) {
        var card = button.closest('.product-grid-item, .gl-card');
        if (!button.classList.contains('tp-search-wishlist')) button.classList.add('tp-search-wishlist');
        if (!card) {
          if (button.classList.contains('tp-search-wishlist-ready')) button.classList.remove('tp-search-wishlist-ready');
          return;
        }
        var media = card.querySelector('.product-grid-item__image, .gl-card-thumbnail');
        if (media) {
          activeMedia.add(media);
          if (!media.classList.contains('tp-search-wishlist-media')) media.classList.add('tp-search-wishlist-media');
          // Move, do not clone: preserve the SDK's handler and product identity.
          if (!media.contains(button)) media.appendChild(button);
        }
        if (!button.querySelector('svg.tp-wishlist-heart-svg')) {
          var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('class', 'tp-wishlist-heart-svg');
          svg.setAttribute('viewBox', '0 0 24 24');
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('focusable', 'false');
          var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', heartPath);
          svg.appendChild(path);
          button.appendChild(svg);
        }
      });
    });
    // swymcs-collections-reinit.js owns SDK initialization. An SDK object can
    // exist before it is ready; do not initialize it prematurely from here.
    document.querySelectorAll('.tp-search-wishlist').forEach(function (button) {
      var card = button.closest('.product-grid-item, .gl-card');
      var media = card && card.querySelector('.product-grid-item__image, .gl-card-thumbnail');
      var primary = card && card.querySelector(buttonSelector);
      // Never force a dead button visible: require either a bound SDK action or
      // the app's own consent popup, which will load and bind the SDK on accept.
      var ready = button === primary && visibleMedia(media, card) &&
        (button.classList.contains('swym-loaded') ||
        (!window._swat && !!consentPopupAvailable()));
      button.classList.toggle('tp-search-wishlist-ready', ready);
      if (card && button === primary) card.classList.toggle('tp-search-wishlist-card-ready', ready);
    });
    observedMedia.forEach(function (media) {
      if (activeMedia.has(media)) return;
      if (mediaObserver) mediaObserver.unobserve(media);
      media.classList.remove('tp-search-wishlist-media');
    });
    activeMedia.forEach(function (media) {
      if (mediaObserver && !observedMedia.has(media)) mediaObserver.observe(media);
    });
    observedMedia = activeMedia;
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(refresh, 80);
  }

  function replayWhenBound(button) {
    var attempts = 0;
    function tryReplay() {
      if (!button.isConnected) return;
      if (button.classList.contains('swym-loaded')) {
        refresh();
        if (button.classList.contains('tp-search-wishlist-ready')) button.click();
      } else if (++attempts < 40) {
        setTimeout(tryReplay, 250);
      } else {
        refresh();
      }
    }
    tryReplay();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.tp-search-wishlist');
    if (!button || !button.closest(scope)) return;
    refresh();
    if (button.classList.contains('tp-search-wishlist-ready') && button.classList.contains('swym-loaded')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!button.classList.contains('tp-search-wishlist-ready')) return;
    if (consentPopupAvailable() && !window.SwymConsentManager.checkConsent()) {
      window.SwymConsentPopupManager.show({
        source: 'trendsplant-search-wishlist',
        pendingAction: function () { replayWhenBound(button); }
      });
    } else if (consentPopupAvailable()) {
      replayWhenBound(button);
    }
  }, true);

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function () { schedule(); });
  ['globoFilterRenderCompleted', 'globoFilterRenderSearchCompleted'].forEach(function (name) {
    window.addEventListener(name, schedule);
  });
  document.addEventListener('visitorConsentCollected', schedule);
  document.addEventListener('theme:filters:init', schedule);

  function start() {
    refresh();
    new MutationObserver(function (records) {
      if (records.some(function (record) {
        return record.type === 'childList' || record.target.closest(scope);
      })) schedule();
    }).observe(document.body, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'href'] });
    window.addEventListener('resize', schedule);
    document.addEventListener('transitionend', schedule, true);
    // App assets are asynchronous and can become available without a DOM write.
    // Bounded startup checks, not a permanent polling loop.
    var startupChecks = 0;
    var startupTimer = setInterval(function () {
      refresh();
      if (++startupChecks >= 40 || window._swat) clearInterval(startupTimer);
    }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
